import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

export default function SalonTeam() {

    var navi = useNavigate();

    var uuid = localStorage.getItem('uuid');
    var name = localStorage.getItem('salonName');

    function addTeam(params) { 

    }

    const [columns, setcolumns] = useState([
        { Label: 'Name' },
        { Label: 'Contact' },
        { Label: 'Role' },
        { Label: 'Actions' },
    ])

    return (
        <>

            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} flexGrow={1} mt={5} pr={3.3} pt={3}>
                    <div className="row m-0 justify-content-between">
                        <Typography variant="h4" className="col-lg-7" fontWeight={'bold'}>Team Members</Typography>
                        <Link to={`/Shop/${name}-${uuid}/Team/Add`} className="btn btn-dark col-lg-1">Add</Link>
                    </div>
                    <TableContainer sx={{ maxHeight: 540, mt: 3 }}>
                        <Table stickyHeader aria-label="sticky table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.Label == 'Actions' ? 'center' : 'left'}
                                            style={{ minWidth: column.minWidth }}
                                        >
                                            {column.Label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* {services?.length > 0 ? (

                                    services.map((row) => (
                                        <TableRow>
                                            <TableCell>{row.Name}</TableCell>
                                            <TableCell>₹{row.Price}</TableCell>
                                            <TableCell>{convertTime(row.Duration)}</TableCell>
                                            <TableCell align="center">
                                                <IconButton onClick={() => deleteService(row)} color="inherit" size="small">
                                                    <Delete />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))
                                ) : (
                                    <>
                                        <br />
                                        <Typography variant="'h6">You haven't added any service</Typography>

                                    </>
                                )} */}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>

        </>
    )

}